import * as storage from '@/utils/storage'

// initial state
const state = {
  history: storage.history.get()
}
// getters
const getters = {
  history: state => state.history,
}

// actions
const actions = {
  saveHistory({ commit }, data) {
    storage.history.set(data)
    commit("saveHistory", data)
  },
  updateTitle({ commit, getters }, data) {
    const history = [...getters.history].map(item => ({...item}))
    history[history.length - 1].title = data
    storage.history.set(history)
    commit("saveHistory", history)
  },
}

// mutations
const mutations = {
  saveHistory(state, history) {
    state.history = history
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
